import FJActionConstant from "../../constant/FJActionConstant";
import FJConfig from "../../config/FJConfig";

const initState = {
  backgroundColor: FJConfig.boardBKColor,
};

export default function (state = initState, action) {
  switch (action.type) {
    case FJActionConstant.SET_BACKGROUND_COLOR_BACKGROUND_COLOR:
      return {
        ...state,
        backgroundColor: action.backgroundColor
      };
    default:
      return state;
  }
}
